export default "__VITE_ASSET__Hm3mYWvP__"